import React, { DetailedHTMLProps, InputHTMLAttributes } from "react";

import classnames from "classnames";

import { H4 } from "../Typography";

type CardHeaderProps = DetailedHTMLProps<
  InputHTMLAttributes<HTMLHeadingElement>,
  HTMLHeadingElement
> & {
  /**
   * The card description
   * @default undefined
   */
  description?: React.ReactNode;
};

const CardHeader: React.FC<CardHeaderProps> = ({
  description,
  children,
  className,
  ...props
}) => {
  const cardHeaderStyle = classnames(
    "px-4 py-5 bg-white border-b border-light-300 sm:px-6",
    className
  );

  return (
    <div className={cardHeaderStyle} {...props}>
      <H4 description={description} className="break-words">{children}</H4>
    </div>
  );
};

export default React.memo(CardHeader);
